import { toLocalizedRiotUrl } from './../utils/language';

export default new (function() {
    this.sendSessionStart = function() {
        $.post(toLocalizedRiotUrl('/selling/api/scribe/session-start'));
    };

    this.sendSessionDuration = function(duration, madeByTemplate) {
        $.post(toLocalizedRiotUrl('/selling/api/scribe/session-duration'), {
            durationMilliSeconds: duration,
            madeByTemplate: madeByTemplate
        });
    };

    this.sendDuration = function(measuredName, durationMilliSeconds) {
        $.post(toLocalizedRiotUrl('/selling/api/scribe/duration'), {
            measuredName: measuredName,
            durationMilliSeconds: durationMilliSeconds
        });
    };

    this.sendIncrement = function(name) {
        $.post(toLocalizedRiotUrl('/selling/api/scribe/increment'), {
            name: name
        });
    };

    this.sendValidationErrors = function(errors) {
        $.post(
            toLocalizedRiotUrl('/selling/api/scribe/form-validation-errors'),
            {
                errors: errors
            }
        );
    };

    this.sendJsError = function(errorMsg) {
        var payload = {
            eventName: 'js-onerror',
            message: errorMsg || '',
            url: '',
            lineNumber: '',
            column: '',
            errorObj: '',
            trace: ''
        };

        var data = JSON.stringify(payload);
        data = data.replace(/</gi, '{');
        data = data.replace(/>/gi, '}');

        $.post(toLocalizedRiotUrl('/scribe'), {
            entries: '[' + data.toString() + ']'
        });
    };
})();
